import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./FAQPop.module.scss";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import {
  useAddFAQMutation,
  useUpdateFAQMutation,
} from "../../../store/services/FAQServices";
import toast from "react-hot-toast";
import CKEditorField from "../../ckEditor/CKEditorField";


const FAQSectionPop = ({ title, modalFaqOpen, setModalFaqOpen, edit }) => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      question: edit?.question,
      status: edit?.status,
      answer: edit?.answer,
      type: edit?.type,
    },
  });

  const [addFAQ, { isLoading: isAdding }] = useAddFAQMutation();
  const [updateFAQ, { isLoading: isUpdating }] = useUpdateFAQMutation();

  // Submit handler
  const onSubmit = async (data) => {
    try {
      let res = "";
      if (edit !== null) {
        // Update existing meal
        res = await updateFAQ({
          ingredientId: edit._id,
          updatedData: data,
        });
      } else {
        res = await addFAQ(data).unwrap(); // Call deleteFAQ and handle success
      }

      setModalFaqOpen(false);
      // return toast.success(res?.data?.message);
      return toast.success(`FAQ ${edit ? "updated" : "added"} successfully`);
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalFaqOpen(false);
  };
  return (
    <Modal
      show={modalFaqOpen}
      className={`${styles.FAQPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                

                
                
              
              </Row>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalFaqOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>

          {/* <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100"
              >
                {title}
              </Button>
            </div>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FAQSectionPop;
